module.exports = __webpack_public_path__ + "img/3.5_Russian_road_sign.6b9abbc2.svg";